import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getContent = () => api.get("/content").then((r) => r.data);

export const adminLogin = (email, password) =>
  api.post("/admin/login", { email, password }).then((r) => r.data);

export const getAdminContent = (token) =>
  api.get("/admin/content", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const saveAdminContent = (token, overrides) =>
  api.put("/admin/content", { overrides }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const getAdminInquiries = (token) =>
  api.get("/admin/inquiries", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const getAdminStats = (token) =>
  api.get("/admin/stats", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const getAdminSubscribers = (token) =>
  api.get("/admin/subscribers", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const runDripNow = (token) =>
  api.post("/admin/drip/run", {}, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const updateInquiry = (token, id, patch) =>
  api.patch(`/admin/inquiries/${id}`, patch, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const getReferrals = (token) =>
  api.get("/admin/referrals", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const getReservations = (token) =>
  api.get("/admin/reservations", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const addReservation = (token, body) =>
  api.post("/admin/reservations", body, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const deleteReservation = (token, id) =>
  api.delete(`/admin/reservations/${id}`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const inviteMarketer = (token, body) =>
  api.post("/admin/referrals/invite", body, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
